import { INSERE_DADOS } from './constants';

export default function insereDadosUsuario(values) {
  return {
    type: INSERE_DADOS,
    values,
  };
}
